export const SEMESTERS = [
	{
		label: "First Semester",
		value: 1
	},
	{
		label: "Second Semester",
		value: 2
	}
];

export const SCHOOL_DETAILS = {
	name: "Abia State College Of Health Sciences And Management Technology, Aba",
	nameWithoutCampus: "Abia State College Of Health Sciences And Management Technology",
	location: "Abia State",
	pmb: "School Road by Mosque, Aba, Abia State",
	pmbWithoutState: "P.M.B. 7016",
	pmbStateOnly: "Aba, Abia State",
	country: "Nigeria",
	shortForm: "ABSCOHMAT",
	rector: "Mr. Alloysius Ekeleme Okezie",
	credentials: "FWAPCMLS, FSEPHCN, FICA",
	registrar: "Elder B. O. Ibendiogwu",
	email: "abscohmat@gmail.com",
	portal: "www.abscohmat.edu.ng",
	phone: "08030930420, 08065254605"
};

export const PAYMENTTYPES = [
	{
		label: "Full Payment",
		value: "Full"
	},
	{
		label: "First Installment",
		value: "FirstInstallment"
	},
	{
		label: "Second Installment",
		value: "SecondInstallment"
	}
];

export const EXTERNAL_STUDENT_PAYMENT_DETAILS = {
	paymentPurpose: "External",
	paymentType: "Full"
};

export const PAYMENTIDENTIFIER = {
	schoolFees: 1,
	acceptance: 2,
	hostelArrears: 16,
	hostel: "Hostel",
	sundry: 9,
	changeOfDepartment: "ChangeOfDepartment"
};

export const PAGESIZE = {
	sm: 5,
	md: 10,
	lg: 15,
	xl: 20,
	xxl: 30
};

export const SEARCH_DELAY = {
	sm: 300,
	md: 500,
	lg: 800,
	xl: 1000
};

export const INITIAL_DATE = "0001-01-01T00:00:00";

export const MINIMUM_AGE = 15;
export const MAXIMUM_AGE = 80;
export const TENECE_SUPPORT_URL = "https://teneceschoolsupport.com/";
export const ABSCOHMATPG_HOSTEL_APPLICATION_LINK = "Not checked yet";
export const ABSCHOMAT_HOSTEL_APPLICATION_LINK = "Not checked yet";
// Authentication Constants
export const TOKEN_HOLDER = `${SCHOOL_DETAILS.shortForm}token`;
export const DISPLAY_CSAT_MODAL = `${SCHOOL_DETAILS.shortForm}displayCSATModal`;
export const USER_ROLE_HOLDER = `${SCHOOL_DETAILS.shortForm}userRole`;
export const USER_NAME_HOLDER = `${SCHOOL_DETAILS.shortForm}userName`;
export const BIRTHDAY_STATE_HOLDER = `${SCHOOL_DETAILS.shortForm}birthday`;
export const STUDENT_TYPE_HOLDER = `${SCHOOL_DETAILS.shortForm}studentType`;
export const REFRESH_TOKEN_HOLDER = `${SCHOOL_DETAILS.shortForm}refreshToken`;
export const USER_TYPES = ["lecturer", "student", "official"];

//Application mode id
export const APPLICATION_MODE = {
	UTME: 8,
	JUPEB: 5,
	DIRECT_ENTRY: 33,
	PG: 7,
	SUPPLEMENTARY: 3,
	PRE_DEGREE: 2,
	CCE: 14,
	STAFF_REQUEST: 16,
	FOUR_YEAR_SANDWICH: 17,
	FIVE_YEAR_SANDWICH: 9,
	// INTER_UNIVERSITY_TRANSFER: 2,
	ND_DIPLOMA: 1,
	HND_DIPLOMA: 2,
	CERTIFICATE_DIPLOMA: 3,
	SUPPLEMENTARY_DIPLOMA: 4,
	SANDWICH_PROGRAMME: 17
};

export const APPLICATION_ID = {
	UTME: 8,
	JUPEB: 5,
	DIRECT_ENTRY: 33,
	PG: 7,
	SUPPLEMENTARY: 15,
	PRE_DEGREE: 10,
	CCE: 16,
	STAFF_REQUEST: 16,
	FOUR_YEAR_SANDWICH: 17,
	FIVE_YEAR_SANDWICH: 9,
	// INTER_UNIVERSITY_TRANSFER: 2,
	ND_DIPLOMA: 1,
	HND_DIPLOMA: 2,
	CERTIFICATE_DIPLOMA: 3,
	SUPPLEMENTARY_DIPLOMA: 4,
	SANDWICH_PROGRAMME: 17,
	PUTME_SLIP: 24
};

export const STUDENT_TYPES = {
	UNDERGRADUATE: 1,
	JUPEB: 8,
	Diploma: 5,
	POSTGRADUATE: 2,
	Sandwich: 9,
	"Sandwich Diploma": 10,
	INTER_UNIVERSITY_TRANSFER: 2
};

export const POST_GRADUATE_DETAILS = {
	deputyRegister: "Not checked yet",
	correspondence: "Not checked yet",
	correspondenceEmail: "Not checked yet",
	provost: "Not checked yet",
	provostEmail: "Not checked yet"
};

export const CertificateTypeIds = {
	NCE: 3,
	ACE: 9,
	TC: 10
};
